const orderedCollectionStyles = {
  wrapper: {
    overflow: 'hidden',
    border: 0,
    borderRadius: 0,
    background: '#fff',
  },
  toolbar: {
    display: 'flex',
    minHeight: 52,
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    padding: '8px 20px',
    borderBottom: '1px solid #edf2f0',
    background: '#fbfefd',
  },
  toolbarSummary: {
    minWidth: 0,
    color: '#66708a',
    fontSize: 13,
    lineHeight: 1.45,
  },
  toolbarStrong: {
    color: '#1e2248',
    fontWeight: 600,
  },
  toolbarActions: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    gap: 8,
  },
  resetButton: {
    display: 'inline-flex',
    minHeight: 36,
    alignItems: 'center',
    gap: 6,
    padding: '5px 10px',
    border: 0,
    borderRadius: 8,
    background: 'transparent',
    color: '#66708a',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: 12,
    fontWeight: 600,
  },
  resetIcon: { fontSize: 17 },
  zone: { background: '#fff' },
  row: {
    display: 'grid',
    width: '100%',
    minHeight: 56,
    boxSizing: 'border-box',
    alignItems: 'center',
    gap: 10,
    padding: '8px 20px',
    borderBottom: '1px solid #edf2f0',
    background: '#fff',
    cursor: 'grab',
    transition: 'background-color 140ms ease, box-shadow 140ms ease',
  },
  rowDragging: {
    borderRadius: 8,
    cursor: 'grabbing',
    boxShadow: '0 8px 22px rgba(30, 34, 72, 0.14)',
  },
  rowPinned: {
    background: 'var(--kea-color-primary-surface)',
  },
  dragHandle: {
    display: 'flex',
    width: 32,
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
    color: '#8790a5',
    cursor: 'grab',
    userSelect: 'none',
  },
  dragIcon: { fontSize: 20 },
  pinnedPosition: {
    display: 'flex',
    width: 32,
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--kea-color-primary)',
    fontSize: 12,
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
  },
  itemMain: { minWidth: 0 },
  itemName: {
    minWidth: 0,
    overflow: 'hidden',
    color: '#1e2248',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.35,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  itemMeta: {
    minWidth: 0,
    marginTop: 2,
    overflow: 'hidden',
    color: '#66708a',
    fontSize: 12,
    lineHeight: 1.35,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  automaticBadge: {
    display: 'inline-flex',
    minHeight: 24,
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: 999,
    background: '#f1f3f6',
    color: '#66708a',
    fontSize: 11,
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  actionButton: {
    width: 36,
    height: 36,
    padding: 0,
    color: '#8790a5',
    transition: 'opacity 140ms ease, color 140ms ease, background-color 140ms ease',
  },
  emptyState: {
    margin: '12px 16px',
    padding: '24px 16px',
    border: '1px dashed #c8d9d2',
    borderRadius: 8,
    background: '#fbfefd',
    color: '#66708a',
    fontSize: 13,
    lineHeight: 1.5,
    textAlign: 'center',
  },
  addRow: {
    display: 'flex',
    gap: 8,
    padding: '12px 20px',
    borderBottom: '1px solid #edf2f0',
    background: '#fbfefd',
  },
  addInput: {
    flex: 1,
    minWidth: 0,
    minHeight: 40,
    padding: '8px 12px',
    border: '1px solid #d5e1dd',
    borderRadius: 8,
    color: '#1e2248',
    fontSize: 13,
  },
  addButton: {
    minHeight: 40,
    padding: '0 14px',
    border: '1px solid var(--kea-color-primary-border)',
    borderRadius: 999,
    background: '#fff',
    color: 'var(--kea-color-primary)',
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  hiddenZone: {
    borderTop: '1px solid #edf2f0',
    background: '#fbfefd',
  },
  hiddenTitle: {
    padding: '10px 20px 6px',
    color: '#66708a',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  hiddenRow: {
    display: 'grid',
    minHeight: 44,
    gridTemplateColumns: 'minmax(0, 1fr) 36px',
    alignItems: 'center',
    gap: 8,
    padding: '4px 20px',
    borderTop: '1px solid #edf2f0',
    color: '#66708a',
    fontSize: 13,
  },
  hiddenMediaRow: {
    display: 'grid',
    minHeight: 58,
    gridTemplateColumns: '40px minmax(0, 1fr) 36px',
    alignItems: 'center',
    gap: 10,
    padding: '6px 20px',
    borderTop: '1px solid #edf2f0',
    color: '#66708a',
    fontSize: 13,
  },
  hiddenMedia: {
    width: 40,
    height: 40,
    borderRadius: 6,
    filter: 'grayscale(1)',
    opacity: 0.5,
  },
  hiddenText: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

export default orderedCollectionStyles;
